import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'contexts/AuthContext';

export interface WorkspaceSubscriptionResponse {
  hasActiveSubscription: boolean;
  source: 'database' | 'razorpay' | 'combined';
  subscriptionId?: string;
  isPaused?: boolean;
  lastUpdated?: string;
  lastChecked?: string;
}

export const useGetWorkspaceSubscriptions = (workspaceSlug: string, enabled = true) => {
  const { authApi } = useAuth();

  return useQuery<WorkspaceSubscriptionResponse>({
    queryKey: ['subscription', workspaceSlug],
    queryFn: async () => {
      if (!workspaceSlug) {
        throw new Error('Workspace slug is required');
      }
      const response = await authApi.get<WorkspaceSubscriptionResponse>(`/workspace/${workspaceSlug}/subscription`);
      return response.data;
    },
    enabled: !!workspaceSlug && enabled,
    refetchOnWindowFocus: false
  });
};
